import React from 'react';
import PropTypes from 'prop-types';
import Heading from '../Heading/Heading';
import * as S from './PageHeading.styles';

const PageHeading = ({ className, title, level, ...rest }) => (
    <S.PageHeading className={className}>
      <Heading level={level} title={title} className="pageHeading" {...rest} />
    </S.PageHeading>
  );

PageHeading.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  level: PropTypes.string
};

PageHeading.defaultProps = {
  className: '',
  title: null,
  level: '1'  
};

export default PageHeading;
